import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
  Modal,
  Select,
  Checkbox,
} from "antd";
import signinLogo from "../../assets/images/logo.svg";
import signinbg from "../../assets/images/sign-in-bg.svg";
import MailIcon from "../../assets/images/input-icons/mail-icon.svg";
import PasswordIcon from "../../assets/images/input-icons/lock-icon.svg";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import apiPath from "../../constants/apiPath";
import encryptDecrypt from "../../helper/encryptDecrypt";

import Footer from "../../components/layout/Footer";
import Container from "react-bootstrap/Container";
const { Title } = Typography;
const { Content } = Layout;

const ForgotPasswordIndex = () => {
  const { setIsLoggedIn, setUserProfile } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const { request } = useRequest();
  const navigate = useNavigate();
  const [form1] = Form.useForm();
  const [form] = Form.useForm();
  // const [form] = Form.useForm();
  const [rememberMe, setRememberMe] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpConfirm, setOtpConfirm] = useState(false);

  const [emailFeild, setEmailFeild] = useState(false);
  const [otpFeild, setOtpFeild] = useState(false);

  const [otp, setOtp] = useState(["", "", "", ""]);
  const handleChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setOtpFeild(newOtp.join(''));
      // Auto-focus to next input
      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };
  const handleRememberMeChange = (e) => {
    console.log(e.target.checked);
    setRememberMe(e.target.checked);
  };

  const onFinishEmail = (values) => {
    onSubmitEmail(values);
  };
  const onSubmitEmail = (values) => {

    const { email } = values;
    setEmailFeild(email);
    setLoading(true);
    request({
      url: apiPath.forgotPassword,
      method: "POST",
      data: {
        email:email,
      },
      onSuccess: (data) => {
        setLoading(false);
        console.log(data.status)
        ShowToast(data.message, Severty.SUCCESS);
        setOtpSent(true)
        setOtpConfirm(false)
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });

  };
  const onFinishFailedEmail = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinishOtp = () => {
    onSubmitOtp();
  };
  const onSubmitOtp = () => {
    // const { otp } = values;
    setLoading(true);
    request({
      url: apiPath.verifyOTP,
      method: "POST",
      data: {
        otp:otpFeild,
        email:emailFeild
      },
      onSuccess: (data) => {
        setLoading(false);
        console.log(data.status)
        ShowToast(data.message, Severty.SUCCESS);
        setOtpSent(true)
        setOtpConfirm(true)
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });

  };
  const onFinishFailedOtp = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    onSubmit(values);
  };

  const onSubmit = (values) => {
    const {  password } = values;
    const payload = { password };
    setLoading(true);
    payload.email = emailFeild;
    console.log(payload)
    request({
      url: apiPath.resetPassword,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        console.log(data, "fghdjh data");
        if (data.status) {

          setIsLoggedIn(true);
          setTimeout(() => navigate("/successfully-verified"), 200);

        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("ykmCe2AYEFTHobn");
    const savedPassword = localStorage.getItem("ouUsippetc8S4Ry");

    if (savedEmail && savedPassword) {
      var originalEmail = encryptDecrypt.decryptEmail(savedEmail);
      var originalPassword = encryptDecrypt.decryptEmail(savedPassword);

      form.setFieldsValue({
        email: originalEmail,
        password: originalPassword,
        remember: true,
      });
      setRememberMe(true);
    } else {
      setRememberMe(false);
    }
  }, []);

  return (
    <>
      {!otpSent && !otpConfirm && (
        <Layout className="layout-default layout-signin">
          <Container>
            <Content className="signin">
              <div className="signup-logo-header">
                <img src={signinLogo} alt="" />
              </div>
              <Row>
                <Col span={24} lg={12} className="contant-bg-sign">
                  <div className="signin-box">
                    <Row justify="space-around">
                      <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                        <div className="signup-form">
                          <Title className="mb-15">Forgot Password</Title>
                          <Title className="font-regular text-muted" level={5}>
                            Please Enter your registered email to receive a
                            verification code
                          </Title>
                          <Form
                            form={form1}
                            onFinish={onFinishEmail}
                            onFinishFailed={onFinishFailedEmail}
                            layout="vertical"
                            className="row-col"
                          >
                            <Form.Item
                              className="username"
                              label="Enter your email ID"
                              name="email"
                              rules={[
                                {
                                  type: "email",
                                  message: "Please enter a valid email address!",
                                },
                                {
                                  max: 255,
                                  message:
                                    "Email address not more then 255 characters!",
                                },
                                {
                                  required: true,
                                  message: "Please enter your email!",
                                },
                              ]}
                            >
                              <Input
                                prefix={<img src={MailIcon} />}
                                placeholder="Enter your email ID"
                              />
                            </Form.Item>

                            <Form.Item className="sign-footer-button">
                              <Button
                                className="float-right"
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                              >
                                Continue
                              </Button>
                            </Form.Item>
                          </Form>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col span={24} lg={12} className="signin-bg d-none d-lg-block">
                  <div className="signin_img">
                    <img src={signinbg} />
                  </div>
                </Col>
              </Row>
            </Content>
          </Container>
          <Footer />
        </Layout>
      )}

      {/* Reset Password Page */}

      {otpSent && !otpConfirm && (
        <Layout className="layout-default layout-signin">
          <Container>
            <Content className="signin">
              <div className="signup-logo-header">
                <img src={signinLogo} alt="" />
              </div>
              <Row>
                <Col span={24} lg={12} className="contant-bg-sign">
                  <div className="signin-box">
                    <Row justify="space-around">
                      <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                        <div className="signup-form">
                          <Title className="mb-15">OTP Verification</Title>
                          <h6 className="sub-headding-sign">
                            Enter the verification code we sent to your Email ID{" "}
                            {emailFeild}
                          </h6>
                          <Form
                            form={form}
                            onFinish={onFinishOtp}
                            onFinishFailed={onFinishFailedOtp}
                            layout="vertical"
                            className="row-col"
                          >
                            <Form.Item
                              name="otp"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter the OTP",
                                },
                                {
                                  validator: (_, value) => {
                                    return otp.join("").length === 4
                                      ? Promise.resolve()
                                      : Promise.reject(
                                          new Error("OTP must be 4 digits")
                                        );
                                  },
                                },
                              ]}
                            >
                              <div className="otp-inputs-line">
                                {otp.map((digit, index) => (
                                  <Input
                                    key={index}
                                    id={`otp-${index}`}
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) =>
                                      handleChange(e.target.value, index)
                                    }
                                    style={{ width: "3rem", textAlign: "center" }}
                                  />
                                ))}
                              </div>
                            </Form.Item>
                            <div className="forgot-pass">
                              <Form.Item
                                name="remember"
                                className="aligin-center"
                                valuePropName="checked"
                              >
                                <Checkbox
                                  className="rem-check"
                                  checked={rememberMe}
                                  onChange={handleRememberMeChange}
                                >
                                  Didn’t receive OTP?
                                </Checkbox>
                              </Form.Item>
                              <div className="resend-otp-main">
                                Resend OTP
                                <span> 50s</span>
                              </div>
                            </div>
                            <Form.Item className="sign-footer-button">
                              <Button
                                className="float-right"
                                type="primary"
                                htmlType="submit"
                                // onClick={() => navigate("/successfully-verified")}
                              >
                                Continue
                              </Button>
                            </Form.Item>
                          </Form>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col span={24} lg={12} className="signin-bg d-none d-lg-block">
                  <div className="signin_img">
                    <img src={signinbg} />
                  </div>
                </Col>
              </Row>
            </Content>
          </Container>
          <Footer />
        </Layout>
      )}

      {otpSent && otpConfirm && (
        <Layout className="layout-default layout-signin">
        <Container>
          <Content className="signin">
            <div className="signup-logo-header">
              <img src={signinLogo} alt="" />
            </div>
            <Row>
              <Col span={24} lg={12} className="contant-bg-sign">
                <div className="signin-box">
                  <Row justify="space-around">
                    <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                      <div className="signup-form">
                        <Title className="mb-15">Reset Password</Title>
                        <Title className="font-regular text-muted" level={5}>
                          Your password must be different and contain at-least 3
                          special characters.
                        </Title>
                        <Form
                          form={form}
                          onFinish={onFinish}
                          onFinishFailed={onFinishFailed}
                          layout="vertical"
                          className="row-col"
                        >
                          <Form.Item
                            className="username"
                            label="Password"
                            name="password"
                            rules={[
                              {
                                type: "password",
                                message: "Please enter a valid password!",
                              },
                              {
                                max: 255,
                                message:
                                  "password not more then 255 characters!",
                              },
                              {
                                required: true,
                                message: "Please enter your password!",
                              },
                            ]}
                          >
                            <Input
                              prefix={<img src={PasswordIcon} />}
                              placeholder="Enter password"
                            />
                          </Form.Item>
                          <Form.Item
                            className="username"
                            label="Re-enter Password"
                            name="password"
                            rules={[
                              {
                                type: "password",
                                message: "Please enter a valid password!",
                              },
                              {
                                max: 255,
                                message:
                                  "password not more then 255 characters!",
                              },
                              {
                                required: true,
                                message: "Please enter your password!",
                              },
                            ]}
                          >
                            <Input
                              prefix={<img src={PasswordIcon} />}
                              placeholder="Re-Enter password"
                            />
                          </Form.Item>

                          <Form.Item className="sign-footer-button">
                            <Button
                              className="float-right"
                              type="primary"
                              htmlType="submit"
                              loading={loading}
                            >
                              Continue
                            </Button>
                          </Form.Item>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={24} lg={12} className="signin-bg d-none d-lg-block">
                <div className="signin_img">
                  <img src={signinbg} />
                </div>
              </Col>
            </Row>
          </Content>
        </Container>
        <Footer />
        </Layout> 
      )}
    </>
  );
};

export default ForgotPasswordIndex;
